module.exports = __webpack_public_path__ + "42281b04388fe96e0da54180a1663790.png";